/** Типы отчёта — влияют на промпт, акценты анализа и группировку. */
export const RESEARCH_REPORT_TYPES = {
  startup: {
    label: "Стартап",
    description: "Валидация гипотезы, PMF, ранние клиенты и масштабирование",
    promptFocus:
      "фокус на product-market fit, early adopters, unit-экономику SaaS/tech и путь к seed/Series A",
  },
  business_opening: {
    label: "Открытие бизнеса",
    description: "Запуск офлайн/локального бизнеса, разрешения, первые продажи",
    promptFocus:
      "фокус на локальный спрос, CAPEX/OPEX, срок окупаемости точки, разрешительную базу и операционку",
  },
  investment: {
    label: "Инвестиции",
    description: "Оценка ниши для вложения капитала: доходность, риски, горизонт",
    promptFocus:
      "фокус на IRR/мультипликаторы, риск-профиль, ликвидность выхода и портфельную логику инвестора",
  },
  purchase: {
    label: "Покупка",
    description: "Покупка франшизы или готового бизнеса: due diligence и окупаемость",
    promptFocus:
      "фокус на паушальный взнос, роялти, payback покупки, due diligence и скрытые обязательства",
  },
  current_business: {
    label: "Текущий бизнес",
    description:
      "Действующая компания: выход в смежную нишу, расширение ассортимента или географии",
    promptFocus:
      "фокус на расширение действующего бизнеса: смежные рынки, синергии с текущими активами (бренд, каналы, закупка), риск каннибализации, пилот и масштабирование без «стартапа с нуля»",
  },
} as const;

export type ResearchReportType = keyof typeof RESEARCH_REPORT_TYPES;

export const RESEARCH_REPORT_TYPE_VALUES = Object.keys(
  RESEARCH_REPORT_TYPES,
) as ResearchReportType[];

export function isResearchReportType(value: string): value is ResearchReportType {
  return value in RESEARCH_REPORT_TYPES;
}

export function getReportTypeLabel(type?: string | null): string {
  if (type && isResearchReportType(type)) {
    return RESEARCH_REPORT_TYPES[type].label;
  }
  return RESEARCH_REPORT_TYPES.startup.label;
}

export function getReportTypePromptFocus(type?: string | null): string {
  if (type && isResearchReportType(type)) {
    return RESEARCH_REPORT_TYPES[type].promptFocus;
  }
  return RESEARCH_REPORT_TYPES.startup.promptFocus;
}
